import type { AuthenticationResponseJSON } from '@simplewebauthn/browser'
import { http } from '../../config/axios'
import { AuthenticationResponse } from '../postLogin/postLoginService'

const postAuthenticationPasskeyFinalizar = (
  sessionId: string,
  credential: AuthenticationResponseJSON
): Promise<AuthenticationResponse> => {
  return http
    .post(
      'api/gatewaybiro/authentication-passkey-finalizar',
      { sessionId, credential },
      { headers: { originLogin: 'web' } }
    )
    .then((res) => {
      return res.data as AuthenticationResponse
    })
    .catch((error) => {
      console.error('Erro postAuthenticationPasskeyFinalizar', error)
      throw Error(error.response?.data)
    })
}

export default postAuthenticationPasskeyFinalizar
